// removed by extract-text-webpack-plugin
module.exports = {"content":"UnknownError__content","message":"UnknownError__message","okButton":"UnknownError__okButton","growDotQello":"UnknownError__growDotQello","growDotBlue":"UnknownError__growDotBlue","growDotGolden":"UnknownError__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/UnknownError/UnknownError.scss
// module id = 1877
// module chunks = 0